/**
 * Отбор раздела «Планы» адресом: трёхпозиционные переключатели, первая
 * строка списков, набор поставщиков. Вынесено из `pages/PlansPage.tsx`
 * (нарезка 14.10.26).
 */

import type { ComboOption } from "@/components/Combo";

/**
 * Трёхпозиционный отбор адресом: `yes` → `"true"`, `no` → `"false"`, пусто —
 * параметра нет вовсе.
 *
 * СТРОКОЙ, а не булевым: `query()` выбрасывает `false` вместе с пустыми
 * значениями (`lib/api.ts`), и «нет» молча превратилось бы во «все».
 */
export function тристорона(value: string | null): string {
  return value === "yes" ? "true" : value === "no" ? "false" : "";
}

/** Варианты трёхпозиционного отбора: «все» стоит первым и отмечено по умолчанию. */
export const ТРИ = [
  { value: "", label: "все" },
  { value: "yes", label: "есть" },
  { value: "no", label: "нет" },
];

export const ТРИ_ОПЛАТА = [
  { value: "", label: "все" },
  { value: "yes", label: "оплачено" },
  { value: "no", label: "нет" },
];

/** Первая строка любого списка отбора — снять отбор. */
export const ВСЕ: ComboOption = { value: "", label: "все" };

/** `supplier=1,2,3` из адреса — номерами строками; пустая строка — пустой список. */
export function поставщики(raw: string | null): string[] {
  if (!raw) return [];
  return raw.split(",").filter((id) => /^\d+$/.test(id));
}
